import React, { useState } from 'react'
import * as Yup from 'yup';
import dynamic from 'next/dynamic'


const BorderBtn = dynamic(() => import('../../Common/BorderBtn', { ssr: false }));

export default function EnquireBundleDiscount({ sampleSlug }) {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const fieldsEnquiryPriceForm = [
        {
            name: 'name',
            label: '',
            placeholder: 'Full Name*',
            validation: Yup.string().required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: 'Add Your Company E-mail Address*',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'

        },
    ];
    return (
        <div className='relative'>
            <BorderBtn
                customClass='w-full flex flex-start px-4 py-2 font-semibold hightLightBtn2 text-white justify-center text-sm mt-2 rounded hover:bg-[#0c4ad9]'
                buttonTitle='Enquire for Bundle Reports Discounts'
                form_name="bundle-discount-price-enquiry"
                formTitle="Please enter your details to get an additional discount for purchasing 2 or more reports."
                customFields={fieldsEnquiryPriceForm}
                endpoint="/enquiry/bundle-discount-price-enquiry"
                onclick={openModal}
                page_name={`Bundle Discount`}
                product_name={sampleSlug}
            />
            <div className={`absolute -top-[23px] -right-[22px] transition-all duration-500 ease-in-out transform translate-x-0 opacity-100 `}>
                <div className="absolute top-0 right-0 z-50 w-12 h-12 overflow-hidden rotate-45">
                    <div className={`bg-red-600 text-primary-foreground shadow-lg transform rotate-45 origin-bottom-left absolute top-0 right-0 w-20 h-20 transition-transform duration-500 ease-out translate-x-0 translate-y-0 `}></div>
                    <div className="absolute top-[32px] right-[9px] z-10 rounded text-white transform text-xs font-bold">
                        {`Offer`}
                    </div>
                </div>
            </div>
        </div>
    )
}